import React, { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Offcanvas, Button } from "react-bootstrap";
import {
  Home,
  Users,
  ReceiptText,
  Wallet,
  ChartNoAxesCombined,
  BookOpen,
  LogOut,
  Menu,
  ChevronDown,
  Building2,
} from "lucide-react";
import { visibleGroups } from "./navigation";
import { useSession } from "../auth/SessionProvider";
const icons = {
  Inicio: Home,
  CRM: Users,
  Ventas: ReceiptText,
  Cobranza: Wallet,
  Finanzas: Wallet,
  Reportes: ChartNoAxesCombined,
  Catálogos: BookOpen,
};
export default function AppLayout() {
  const { session, logout } = useSession();
  const [open, setOpen] = useState(false);
  const menu = (
    <>
      <div className="brand">
        <img className="brand-logo" src="/uxbi-logo.svg" alt="UXBI" />
      </div>
      <nav>
        {visibleGroups(session.modules).map((g) => {
          const Icon = icons[g.label];
          return g.items ? (
            <details key={g.label}>
              <summary>
                <Icon size={19} />
                {g.label === "Reportes" ? (
                  <NavLink
                    className="group-link"
                    to="/reportes"
                    onClick={() => setOpen(false)}
                  >
                    Reportes
                  </NavLink>
                ) : (
                  g.label
                )}
                <ChevronDown size={14} />
              </summary>
              {g.items.map(([label, path]) => (
                <NavLink key={path} to={path} end onClick={() => setOpen(false)}>
                  {label}
                </NavLink>
              ))}
            </details>
          ) : (
            <NavLink
              key={g.label}
              to={g.to}
              end
              onClick={() => setOpen(false)}
              className="home-link"
            >
              <Icon size={19} />
              {g.label}
            </NavLink>
          );
        })}
      </nav>
      <footer className="sidebar-footer">
        <Building2 size={19} />
        <div>
          <strong>{session.empresa.nombre}</strong>
          <small>{session.usuario.nombre}</small>
        </div>
        <button title="Cerrar sesión" onClick={logout}>
          <LogOut size={18} />
        </button>
      </footer>
    </>
  );
  return (
    <div className="app-shell">
      <aside className="sidebar">{menu}</aside>
      <div className="main-column">
        <div className="mobile-header">
          <Button
            variant="light"
            aria-label="Abrir menú"
            onClick={() => setOpen(true)}
          >
            <Menu size={22} />
          </Button>
          <span>UXBI · PIEDRAS VIVAS</span>
        </div>
        <main>
          <Outlet />
        </main>
        <div className="app-footer">UXBI · Gestión comercial</div>
      </div>
      <Offcanvas
        className="mobile-menu"
        show={open}
        onHide={() => setOpen(false)}
      >
        <Offcanvas.Header closeButton closeVariant="white">
          <span>Menú</span>
        </Offcanvas.Header>
        <Offcanvas.Body>{menu}</Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}
